import React, { Component } from 'react';
import ReactGA from 'react-ga';
import classnames from 'classnames';
import get from 'lodash/get';
import moment from 'moment';
import { connect } from 'react-redux';
import { updateProfile } from 'actions/userActions';
import { createOrUpdateLanguageProfile } from 'actions/languageProfileActions';
import { PLAN_CATEGORY } from 'config/constants';

import LanguageSelect from './LanguageSelect';
import SkypeNameSelect from './SkypeNameSelect';
import TutorSelect from './TutorSelect';
import LanguageProfile from './LanguageProfile';

class OnBoard extends Component {
  constructor(props) {
    super(props);

    const { selectedDay, selectedService } = props;
    const freeDate = selectedService.language ? selectedDay : moment().add(1, 'day');
    const category = get(props, 'user.profile.category', PLAN_CATEGORY.LANGUAGE);

    this.state = {
      category: selectedService.language ? selectedService.category : category,
      step: 0, // selectedService.language ? 1 : 0, defaulting to 0 cause user hasn't selected a language yet
      language: selectedService.language ? selectedService.language : '',
      freeDate: freeDate.format('ddd, MM/DD').toUpperCase(),
      skypeName: '',
      fullName: '',
      charCount: 0, // Language profile additional info character count
      languageProfile: {
        level: '', // Beginner, Intermediate, Advanced
        additionalInfo: '',
        selectedReasonId: '',
        otherReason: '', // Exists when selected other option from learning reasons
      },
    };
  }

  componentDidMount() {
    fbq('track', 'Lead'); // eslint-disable-line

    ReactGA.initialize('UA-49918148-2', {
      gaOptions: {
        userId: this.props.user.id
      }
    });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  handleSelectLanguage = (language) => {
    this.setState({ language, step: 1 });
  }

  handleChangeSkype = (username) => {
    this.setState({ skypeName: username });
  }

  handleChangeLanguageProfile = (name, value) => {
    this.setState({ languageProfile: { ...this.state.languageProfile, [name]: value } });
  }

  handleSubmitLanguageProfile = (callback) => {
    const { languageProfile, language } = this.state;

    const languageProfileData = {
      language,
      level: languageProfile.level,
      learningReasonId: parseInt(languageProfile.selectedReasonId),
      additionalInfo: languageProfile.additionalInfo.trim(),
      otherReason: languageProfile.otherReason.trim()
    };

    this.props.createOrUpdateLanguageProfile(languageProfileData, () => {
      this.setState(prevState => ({ step: prevState.step + 1 }));
    }, (error) => {
      callback && callback(get(error, 'message', 'Something went wrong'));
    });
  }

  handleClickNextStep = () => {
    const {
      category, language, freeDate, skypeName, step
    } = this.state;

    if (step === 2) {
      const profileData = {
        category,
        language,
        freeDate: moment(freeDate, 'ddd, MM/DD'),
        skypeName: skypeName.trim(),
        onboard: true
      };
      this.props.updateProfile(profileData, true);
    } else {
      this.setState(prevState => ({
        step: prevState.step + 1
      }));
    }
  }

  handleClickPrevStep = () => {
    if (this.state.step === 1) {
      this.setState({
        languageProfile: {
          ...this.state.languageProfile,
          level: '',
          additionalInfo: '',
          selectedReasonId: '',
          otherReason: '',
        }
      });
    }
    
    this.setState({
      step: Math.max(0, this.state.step - 1)
    });
  }

  render() {
    const { selectedService } = this.props;
    const {
      category, language, skypeName, languageProfile, step
    } = this.state;

    let stepContent = null;
    switch (step) {
      case 0:
        stepContent =
          category === 'language' ? (
            <LanguageSelect language={language} onSelect={this.handleSelectLanguage} />
          ) : (
              <TutorSelect onSelect={this.handleSelectLanguage} />
            );
        break;
      case 1:
        stepContent = (
          <LanguageProfile
            languageProfile={languageProfile}
            language={language}
            onBack={this.handleClickPrevStep}
            onNext={this.handleSubmitLanguageProfile}
            onChange={this.handleChangeLanguageProfile}
          />
        );
        break;
      case 2:
        stepContent = (
          <SkypeNameSelect
            username={skypeName}
            onBack={selectedService.language ? undefined : this.handleClickPrevStep}
            onNext={this.handleClickNextStep}
            onChange={this.handleChangeSkype}
          />
        );
        break;
      default:
        stepContent = null;
        break;
    }

    return <div className={classnames('OnBoard', { 'has-footer': step !== 0 })}>{stepContent}</div>;
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    selectedDay: state.filters.selectedDay,
    selectedService: state.filters.selectedService
  };
}

export default connect(
  mapStateToProps,
  { updateProfile, createOrUpdateLanguageProfile }
)(OnBoard);



// WEBPACK FOOTER //
// ./src/pages/student/OnBoard/index.js